"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exchangeCodeForTokens = exports.login = exports.isFederatedUser = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const actionTypes = require("../../actionTypes/auth/login");
const actions = require("../../actions/auth/login");
const validation_1 = require("../../utils/validation");
const iFederatedResponse = t.intersection([
    t.interface({
        isFederated: t.boolean
    }),
    t.partial({
        provider: t.string
    })
]);
function isFederatedUser(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.IS_FEDERATED), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/auth/is-federated/${action.payload}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validate = iFederatedResponse.decode(response);
        const act = validate.fold((e) => actions.isFederatedFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)), (c) => {
            return actions.isFederatedSuccess(c);
        });
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.of)(actions.isFederatedFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)));
    }))));
}
exports.isFederatedUser = isFederatedUser;
const validateStep = (action) => (store) => {
    const validation = (0, validation_1.ap)((0, validation_1.isEmail)('email')(action.payload.email))((0, validation_1.isNotEmpty)('password')(action.payload));
    return validation;
};
function login(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.LOGIN_REQUEST), (0, operators_1.mergeMap)((action) => validateStep(action)(store.value).fold((e) => (0, rxjs_1.of)(actions.validateLoginFailure(e)), (_) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: {
            email: action.payload.email,
            password: action.payload.password
        },
        url: `${baseUrl}api/auth/login`
    }).pipe((0, operators_1.mergeMap)(({ response }) => (0, rxjs_1.of)(actions.loginSuccessAction(response.token))), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.of)(actions.loginFailureAction((0, errorHandling_1.parseAjaxErrorResponse)(error)));
    })))));
}
exports.login = login;
function exchangeCodeForTokens(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.EXCHANGE_CODE_FOR_TOKENS_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/auth/exchange-token`,
        body: action.payload
    })), (0, operators_1.mergeMap)(({ response }) => {
        return (0, rxjs_1.of)(actions.exchangeCodeForTokensSuccess(response.token));
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.exchangeCodeForTokensFailure((0, errorHandling_1.parseAjaxErrorResponse)(err)))));
}
exports.exchangeCodeForTokens = exchangeCodeForTokens;
//# sourceMappingURL=login.js.map